import Dashboard from "./types/Dashboard.js";
import DashboardCard from "./types/DashboardCard.js";
import MapCard from "./types/MapCard.js";
import DataCard from "./types/DataCard.js";
import HistoryCard from "./types/HistoryCard.js";
import ResponsiveTable from "./types/ResponsiveTable.js"; // import ConverterRsrcs from './ConverterRsrcs'
export default {
  install(molten) {
    // molten.addPlugin( 'Molten.LoggedIn', {
    //   sort : 100000,
    //   onLoggedIn : async ( ) => {
    //     const c = new ConverterRsrcs()
    //     c.run()
    //   }
    // } )
    molten.addPlugin('ViewerModelConverter', {
      type: Dashboard.TYPE,
      converter: Dashboard
    });
    molten.addPlugin('ViewerModelConverter', {
      type: Dashboard.GRID_TYPE,
      converter: Dashboard
    });
    molten.addPlugin('ViewerModelConverter', {
      type: DashboardCard.TYPE,
      converter: DashboardCard
    });
    molten.addPlugin('ViewerModelConverter', {
      type: MapCard.TYPE,
      converter: MapCard
    });
    molten.addPlugin('ViewerModelConverter', {
      type: DataCard.TYPE,
      converter: DataCard
    });
    molten.addPlugin('ViewerModelConverter', {
      type: HistoryCard.TYPE,
      converter: HistoryCard
    });
    molten.addPlugin('ViewerModelConverter', {
      type: ResponsiveTable.TYPE,
      converter: ResponsiveTable
    });
  }
};